import * as classnames from 'classnames/bind'
import * as React from 'react'
import { connect } from 'react-redux'
import BasicLayout from '../../layouts/BasicLayout'
import { RootState } from '../../store'
import styles from './dev-page.scss'

const cx = classnames.bind({ ...styles })

interface IProps extends Partial<ReturnType<typeof mapState>> {

}

class DevPage extends React.Component<IProps> {
  public render() {
    return (
      <BasicLayout>
        <div className={cx()}>Dev Page</div>
      </BasicLayout>
    )
  }
}

const mapState = ({ }: RootState) => ({
})

export default connect(mapState)(DevPage)



// WEBPACK FOOTER //
// ./src/pages/DevPage/index.tsx